package chat.amp.tim

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import de.connect2x.messenger.compose.view.roomlist.RoomList

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import de.connect2x.messenger.compose.view.DI
import de.connect2x.messenger.compose.view.get
import de.connect2x.messenger.compose.view.i18n.I18nView
import de.connect2x.messenger.compose.view.roomlist.header.AccountData
import de.connect2x.messenger.compose.view.roomlist.header.NotVerifiedBanner
import de.connect2x.messenger.compose.view.roomlist.header.SearchRoomsBanner
import de.connect2x.messenger.compose.view.roomlist.header.SyncErrorBanner
import de.connect2x.messenger.compose.view.theme.components
import de.connect2x.messenger.compose.view.theme.components.ModalDialogContent
import de.connect2x.messenger.compose.view.theme.components.ModalDialogFooter
import de.connect2x.messenger.compose.view.theme.components.ModalDialogHeader
import de.connect2x.messenger.compose.view.theme.components.ThemedButton
import de.connect2x.messenger.compose.view.theme.components.ThemedModalDialog
import de.connect2x.messenger.compose.view.theme.components.ThemedSurface
import de.connect2x.trixnity.messenger.viewmodel.roomlist.RoomListViewModel
import de.connect2x.trixnity.messenger.viewmodel.util.ErrorType

import org.jetbrains.compose.resources.painterResource

/**
 * The logos of the current brand, left and right aligned. Renders nothing for a brand without
 * logos; the logos themselves come from `brands/<id>/brand.toml`.
 */
@Composable
fun HeaderLogos() {
    if (Brand.logos.isEmpty()) return
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Brand.logos.filter { it.slot == LogoSlot.START }.forEach { BrandLogoImage(it) }

        Spacer(modifier = Modifier.weight(1f))

        Brand.logos.filter { it.slot == LogoSlot.END }.forEach { BrandLogoImage(it) }
    }
}

@Composable
private fun BrandLogoImage(logo: BrandLogo) {
    Image(
        painter = painterResource(logo.resource),
        contentDescription = null,
        modifier = Modifier.height(logo.heightDp.dp)
    )
}

class ampRoomListContainerViewImpl : de.connect2x.messenger.compose.view.roomlist.RoomListContainerView {
    @Composable
    override fun create(roomListViewModel: RoomListViewModel) {
        val i18n = DI.get<I18nView>()
        val error = roomListViewModel.error.collectAsState().value
        ThemedSurface(
            style = MaterialTheme.components.sidebar,
        ) {
            if (error != null) {
                ThemedModalDialog({ roomListViewModel.errorDismiss() }) {
                    ModalDialogHeader {
                        Text(i18n.anErrorHasOccurred())
                    }
                    ModalDialogContent {
                        Text(error)
                        if (roomListViewModel.errorType.value == ErrorType.WITH_ACTION) {
                            Text(i18n.roomListRemoveRoom(), color = MaterialTheme.colorScheme.error)
                        }
                    }
                    ModalDialogFooter {
                        ThemedButton(
                            style = MaterialTheme.components.primaryButton,
                            onClick = { roomListViewModel.errorDismiss() },
                        ) {
                            Text(i18n.actionOk())
                        }
                    }
                }
            }
            Column {
                // add logos on top of roomlist
                HeaderLogos()
                HorizontalDivider(Modifier.fillMaxWidth())

                AccountData(roomListViewModel)
                HorizontalDivider(Modifier.fillMaxWidth().width(1.dp))
                NotVerifiedBanner(roomListViewModel)
                SyncErrorBanner(roomListViewModel)
                SearchRoomsBanner(roomListViewModel)
                RoomList(roomListViewModel)
            }
        }
    }
}


